(function() {
  if (window.__metaobjectSectionNavigationInitialized) {
    return;
  }

  window.__metaobjectSectionNavigationInitialized = true;

  if (window.Shopify && window.Shopify.designMode) {
    return;
  }

  var NAVIGATION_SELECTOR = "[data-metaobject-section-navigation]";
  var activeAbortController = null;
  var activeRequestToken = 0;

  function dispatchLoadingEvent(type) {
    document.documentElement.dispatchEvent(
      new CustomEvent(type, {
        bubbles: true
      })
    );
  }

  function extractSectionId(sectionElement) {
    return sectionElement.id.replace("shopify-section-", "");
  }

  function extractBaseSectionId(sectionId) {
    var separatorIndex = sectionId.lastIndexOf("__");

    if (separatorIndex === -1) {
      return sectionId;
    }

    return sectionId.slice(separatorIndex + 2);
  }

  function findSectionByBaseId(root, baseSectionId) {
    if (!root || !baseSectionId) {
      return null;
    }

    if (typeof root.getElementById === "function") {
      var directMatch = root.getElementById("shopify-section-" + baseSectionId);

      if (directMatch && directMatch.classList && directMatch.classList.contains("shopify-section")) {
        return directMatch;
      }
    }

    if (!root.querySelectorAll) {
      return null;
    }

    var sectionElements = root.querySelectorAll('.shopify-section[id^="shopify-section-"]');

    for (var i = 0; i < sectionElements.length; i += 1) {
      var fullSectionId = extractSectionId(sectionElements[i]);

      if (extractBaseSectionId(fullSectionId) === baseSectionId) {
        return sectionElements[i];
      }
    }

    return null;
  }

  function captureNavigationUiState(navElement) {
    if (!navElement) {
      return null;
    }

    var scrollCarousel = navElement.querySelector("scroll-carousel");

    if (!scrollCarousel) {
      return null;
    }

    return {
      scrollCarousel: {
        scrollLeft: scrollCarousel.scrollLeft,
        selectedIndex: typeof scrollCarousel.selectedIndex === "number" ? scrollCarousel.selectedIndex : null
      }
    };
  }

  function restoreNavigationUiState(navigationBaseSectionId, navigationUiState) {
    if (!navigationUiState || !navigationUiState.scrollCarousel) {
      return;
    }

    var prepareScrollCarousel = function() {
      var navSection = findSectionByBaseId(document, navigationBaseSectionId);

      if (!navSection) {
        return null;
      }

      var scrollCarousel = navSection.querySelector("scroll-carousel");

      if (!scrollCarousel) {
        return null;
      }

      scrollCarousel.style.visibility = "hidden";

      return scrollCarousel;
    };

    var revealScrollCarousel = function(scrollCarousel) {
      if (!scrollCarousel) {
        return;
      }

      scrollCarousel.style.removeProperty("visibility");
    };

    prepareScrollCarousel();

    var applyState = function() {
      var navSection = findSectionByBaseId(document, navigationBaseSectionId);

      if (!navSection) {
        return;
      }

      var scrollCarousel = navSection.querySelector("scroll-carousel");

      if (!scrollCarousel) {
        return;
      }

      scrollCarousel.style.visibility = "hidden";

      if (typeof navigationUiState.scrollCarousel.selectedIndex === "number" && typeof scrollCarousel.select === "function") {
        try {
          scrollCarousel.select(navigationUiState.scrollCarousel.selectedIndex, { instant: true });
        } catch (error) {
        }
      }

      scrollCarousel.scrollLeft = navigationUiState.scrollCarousel.scrollLeft;

      requestAnimationFrame(function() {
        revealScrollCarousel(scrollCarousel);
      });
    };

    requestAnimationFrame(function() {
      requestAnimationFrame(applyState);
    });
  }

  function normalizePathname(pathname) {
    if (!pathname) {
      return "/";
    }

    var normalizedPathname = pathname.replace(/\/+$/, "");

    return normalizedPathname === "" ? "/" : normalizedPathname;
  }

  function updateNavigationActiveState(navElement, destinationUrl) {
    if (!navElement || !destinationUrl) {
      return;
    }

    var destinationPathname = normalizePathname(destinationUrl.pathname);
    var mediaLinks = navElement.querySelectorAll("a.multi-column__media[href]");

    mediaLinks.forEach(function(link) {
      var linkUrl;

      try {
        linkUrl = normalizeUrl(link.href);
      } catch (error) {
        return;
      }

      var isActive = linkUrl.origin === destinationUrl.origin && normalizePathname(linkUrl.pathname) === destinationPathname;
      var activeIndicator = link.querySelector(".multi-column__active-indicator");

      link.classList.toggle("multi-column__media--active", isActive);
      if (isActive) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }

      if (isActive && !activeIndicator) {
        activeIndicator = document.createElement("span");
        activeIndicator.className = "multi-column__active-indicator";
        activeIndicator.setAttribute("aria-hidden", "true");
        link.appendChild(activeIndicator);
      } else if (!isActive && activeIndicator) {
        activeIndicator.remove();
      }
    });
  }

  function alignNavigationCarouselToActiveItem(navElement) {
    if (!navElement || !window.matchMedia("(max-width: 699px)").matches) {
      return;
    }

    var scrollCarousel = navElement.querySelector("scroll-carousel");

    if (!scrollCarousel) {
      return;
    }

    var activeMedia = scrollCarousel.querySelector(".multi-column__media--active");

    if (!activeMedia) {
      return;
    }

    var activeItem = activeMedia.closest(".multi-column__item");

    if (!activeItem) {
      return;
    }

    var items = Array.from(scrollCarousel.children);
    var activeIndex = items.indexOf(activeItem);

    if (activeIndex < 0) {
      return;
    }

    var align = function() {
      if (!scrollCarousel.isConnected) {
        return;
      }

      if (typeof scrollCarousel.select === "function") {
        try {
          scrollCarousel.select(activeIndex, { instant: true });
          return;
        } catch (error) {
        }
      }

      scrollCarousel.scrollLeft = activeItem.offsetLeft;
    };

    requestAnimationFrame(function() {
      requestAnimationFrame(align);
    });
  }

  function initializeNavigationCarouselPosition() {
    document.querySelectorAll(NAVIGATION_SELECTOR).forEach(function(navElement) {
      alignNavigationCarouselToActiveItem(navElement);
    });
  }

  function normalizeTargetSectionIds(navElement) {
    var shopifySection = navElement.closest(".shopify-section");

    if (!shopifySection) {
      return [];
    }

    var targetIds = (navElement.dataset.metaobjectSectionNavigationTargetIds || "")
      .split(",")
      .map(function(targetId) {
        return targetId.trim();
      })
      .filter(Boolean)
      .map(function(targetId) {
        return extractBaseSectionId(targetId);
      });

    var sectionIdSet = new Set();
    var normalizedSectionIds = [];

    targetIds.forEach(function(baseSectionId) {
      if (!sectionIdSet.has(baseSectionId)) {
        sectionIdSet.add(baseSectionId);
        normalizedSectionIds.push(baseSectionId);
      }
    });

    return normalizedSectionIds;
  }

  function getSectionHtmlFromResponse(sectionsResponse, baseSectionId) {
    if (!sectionsResponse || typeof sectionsResponse !== "object") {
      return "";
    }

    var directMatch = sectionsResponse[baseSectionId];

    if (typeof directMatch === "string") {
      return directMatch;
    }

    var responseKeys = Object.keys(sectionsResponse);

    for (var i = 0; i < responseKeys.length; i += 1) {
      var responseKey = responseKeys[i];

      if (extractBaseSectionId(responseKey) === baseSectionId && typeof sectionsResponse[responseKey] === "string") {
        return sectionsResponse[responseKey];
      }
    }

    return "";
  }

  function hasRenderableSectionsInResponse(sectionsResponse, baseSectionIds) {
    if (!sectionsResponse || typeof sectionsResponse !== "object") {
      return false;
    }

    return baseSectionIds.some(function(baseSectionId) {
      var html = getSectionHtmlFromResponse(sectionsResponse, baseSectionId);
      return typeof html === "string" && html.trim() !== "";
    });
  }

  function parseSectionMarkup(baseSectionId, html) {
    if (typeof html !== "string" || html.trim() === "") {
      return null;
    }

    var parsedDocument = new DOMParser().parseFromString(html, "text/html");

    return (
      parsedDocument.getElementById("shopify-section-" + baseSectionId) ||
      findSectionByBaseId(parsedDocument, baseSectionId) ||
      parsedDocument.querySelector(".shopify-section")
    );
  }

  async function fetchSectionsResponse(destinationUrl, baseSectionIds, signal) {
    var batches = [];

    // Shopify accepts at most five sections per Section Rendering API request.
    for (var index = 0; index < baseSectionIds.length; index += 5) {
      batches.push(baseSectionIds.slice(index, index + 5));
    }

    var responses = await Promise.all(batches.map(async function(sectionIds) {
      var requestUrl = normalizeUrl(destinationUrl.toString());

      requestUrl.searchParams.delete("section_id");
      requestUrl.searchParams.set("sections", sectionIds.join(","));

      var response = await fetch(requestUrl.toString(), {
        signal: signal,
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Could not fetch section rendering payload.");
      }

      return response.json();
    }));

    return Object.assign.apply(Object, [{}].concat(responses));
  }

  function applySectionResponse(sectionsResponse, baseSectionIds, hostSection) {
    var lastInsertedSection = hostSection;
    var sectionsUpdated = 0;

    baseSectionIds.forEach(function(baseSectionId) {
      var rawHtml = getSectionHtmlFromResponse(sectionsResponse, baseSectionId);
      var parsedSection = parseSectionMarkup(baseSectionId, rawHtml);
      var currentSection = findSectionByBaseId(document, baseSectionId);

      if (currentSection && parsedSection) {
        currentSection.replaceWith(parsedSection);
        sectionsUpdated += 1;
        lastInsertedSection = parsedSection;

        return;
      }

      if (currentSection && !parsedSection && rawHtml.trim() !== "") {
        currentSection.innerHTML = rawHtml;
        sectionsUpdated += 1;
        lastInsertedSection = currentSection;

        return;
      }

      if (currentSection && !parsedSection) {
        currentSection.remove();
        sectionsUpdated += 1;
        return;
      }

      if (!currentSection && parsedSection && lastInsertedSection && lastInsertedSection.parentNode) {
        lastInsertedSection.insertAdjacentElement("afterend", parsedSection);
        lastInsertedSection = parsedSection;
        sectionsUpdated += 1;
      }
    });

    return sectionsUpdated > 0;
  }

  async function fetchFullPageDocument(destinationUrl, signal) {
    var response = await fetch(destinationUrl.toString(), {
      signal: signal,
      headers: {
        Accept: "text/html"
      }
    });

    if (!response.ok) {
      throw new Error("Could not fetch destination HTML.");
    }

    return new DOMParser().parseFromString(await response.text(), "text/html");
  }

  function applySectionsFromDocument(sourceDocument, baseSectionIds, hostSection) {
    var lastInsertedSection = hostSection;
    var sectionsUpdated = 0;

    baseSectionIds.forEach(function(baseSectionId) {
      var currentSection = findSectionByBaseId(document, baseSectionId);
      var sourceSection = findSectionByBaseId(sourceDocument, baseSectionId);

      if (currentSection && sourceSection) {
        currentSection.replaceWith(sourceSection);
        sectionsUpdated += 1;
        lastInsertedSection = sourceSection;

        return;
      }

      if (!currentSection && sourceSection && lastInsertedSection && lastInsertedSection.parentNode) {
        lastInsertedSection.insertAdjacentElement("afterend", sourceSection);
        lastInsertedSection = sourceSection;
        sectionsUpdated += 1;
        return;
      }

      if (currentSection && !sourceSection) {
        currentSection.remove();
        sectionsUpdated += 1;
      }
    });

    return sectionsUpdated > 0;
  }

  function normalizeUrl(inputUrl) {
    return new URL(inputUrl, window.location.origin);
  }

  function isSamePage(urlA, urlB) {
    return (
      urlA.origin === urlB.origin &&
      urlA.pathname === urlB.pathname &&
      urlA.search === urlB.search &&
      urlA.hash === urlB.hash
    );
  }

  async function loadSections(destinationUrl, navElement, shouldPushState) {
    var sectionIds = normalizeTargetSectionIds(navElement);
    var hostSection = navElement.closest(".shopify-section");

    if (!hostSection || sectionIds.length === 0) {
      window.location.assign(destinationUrl.toString());
      return;
    }

    if (activeAbortController) {
      activeAbortController.abort();
    }

    activeAbortController = new AbortController();
    activeRequestToken += 1;
    var requestToken = activeRequestToken;
    dispatchLoadingEvent("theme:loading:start");

    try {
      var sectionsUpdated = false;

      try {
        var sectionsResponse = await fetchSectionsResponse(destinationUrl, sectionIds, activeAbortController.signal);

        if (!hasRenderableSectionsInResponse(sectionsResponse, sectionIds)) {
          throw new Error("Section rendering payload is empty for requested content sections.");
        }

        sectionsUpdated = applySectionResponse(sectionsResponse, sectionIds, hostSection);
      } catch (sectionRenderingError) {
        if (sectionRenderingError && sectionRenderingError.name === "AbortError") {
          return;
        }

        var fallbackDocument = await fetchFullPageDocument(destinationUrl, activeAbortController.signal);
        sectionsUpdated = applySectionsFromDocument(fallbackDocument, sectionIds, hostSection);
      }

      if (!sectionsUpdated) {
        throw new Error("No sections were updated.");
      }

      updateNavigationActiveState(navElement, destinationUrl);

      if (shouldPushState) {
        window.history.pushState({ path: destinationUrl.toString() }, "", destinationUrl.toString());
      }
    } catch (error) {
      if (error && error.name === "AbortError") {
        return;
      }

      window.location.assign(destinationUrl.toString());
    } finally {
      if (requestToken === activeRequestToken) {
        dispatchLoadingEvent("theme:loading:end");
        activeAbortController = null;
      }
    }
  }

  document.addEventListener("click", function(event) {
    if (event.defaultPrevented || event.button !== 0) {
      return;
    }

    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    if (!(event.target instanceof Element)) {
      return;
    }

    var link = event.target.closest(NAVIGATION_SELECTOR + " a[href]");
    if (!link) {
      return;
    }

    if (link.target && link.target !== "_self") {
      return;
    }

    if (link.hasAttribute("download")) {
      return;
    }

    var destinationUrl = normalizeUrl(link.href);
    var currentUrl = normalizeUrl(window.location.href);

    if (destinationUrl.origin !== currentUrl.origin) {
      return;
    }

    if (isSamePage(destinationUrl, currentUrl)) {
      return;
    }

    var navElement = link.closest(NAVIGATION_SELECTOR);
    if (!navElement) {
      return;
    }

    event.preventDefault();
    loadSections(destinationUrl, navElement, true);
  });

  window.addEventListener("popstate", function() {
    var navElement = document.querySelector(NAVIGATION_SELECTOR);
    if (!navElement) {
      return;
    }

    loadSections(normalizeUrl(window.location.href), navElement, false);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeNavigationCarouselPosition, { once: true });
  } else {
    initializeNavigationCarouselPosition();
  }
})();
